<template>
  <v-select
    :class="`ep-select ep-select-${valid ? 'valid' : 'invalid'}`"
    :items="field.choices"
    :loading="field.loading"
    :tabindex="field.tabIndex"
    :placeholder="field.placeholder"
    :style="{
      height: '50px',
      borderRadius: '8px',
      boxShadow: 'none'
    }"
    outlined
    persistent-hint
    v-bind="$attrs"
    v-on="$listeners"
  ></v-select>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "Select",

  props: ["field", "valid"],

  mounted() {},
  computed: {},
  methods: {}
};
</script>

<style lang="scss">
.ep-select {
  fieldset {
    border-color: #e0e0e0 !important;
    background-color: white !important;
  }

  &-invalid {
    fieldset {
      border-color: #ff0000 !important;
      background-color: #ffafaf !important;
    }
  }
}
</style>
